export const createFileName = (title, _id) => { // Web and desktop
  if (title.includes(_id)) {
      return title;
  }

  const baseName = title.includes('.') ? title.match(/(.*)[.]/)[1] || '' : title;
  const extension = title.includes('.') ? title.split('.').pop() : '';
  return `${baseName}_${_id}${extension ? `.${extension}` : ''}`;
};
